import browse from './browse.vue';
import edit from './edit.vue';
import read from './read.vue';

export default { browse, edit, read };
